// src/pages/Policies.js
export default function Policies() {
  return (
    <div className="min-h-screen bg-emerald-50 py-10 px-4 text-gray-800">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow border p-6 md:p-8">
        {/* Header */}
        <header className="mb-6">
          <h1 className="text-2xl md:text-3xl font-extrabold text-emerald-800">
            Policies & Legal Information
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Shine Agri Allied & Marketing Multistate Cooperative Society Ltd.
          </p>
        </header>

        {/* Table of Contents */}
        <nav className="mb-6 bg-emerald-50 border rounded-xl p-4">
          <p className="text-sm font-semibold text-emerald-800 mb-3">Quick Links</p>
          <ul className="grid md:grid-cols-2 gap-y-2 text-sm">
            <li><a className="text-emerald-700 hover:underline" href="#terms">Terms & Conditions</a></li>
            <li><a className="text-emerald-700 hover:underline" href="#privacy">Privacy Policy</a></li>
            <li><a className="text-emerald-700 hover:underline" href="#refunds">Cancellation & Refunds</a></li>
            <li><a className="text-emerald-700 hover:underline" href="#shipping">Shipping / Delivery</a></li>
            <li><a className="text-emerald-700 hover:underline" href="#contact">Contact Us</a></li>
          </ul>
        </nav>

        {/* TERMS */}
        <section id="terms" className="mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-3">
            Terms & Conditions
          </h2>
          <div className="space-y-3 text-sm leading-6">
            <p>
              By accessing or using this website/portal, you agree to be bound by these Terms & Conditions.
              The website and all content are owned and operated by <b>Shine Agri Allied & Marketing Multistate Cooperative Society Ltd.</b> (“We/Us”).
            </p>
            <ul className="list-disc ml-5">
              <li>All registrations, fees and services are governed by the applicable cooperative laws and internal policies.</li>
              <li>Payments for registrations or services are non-transferable.</li>
              <li>We may update these terms at any time. Continued use indicates acceptance of the updated terms.</li>
              <li>Any dispute is subject to jurisdiction of competent courts at Banaskantha, Gujarat, India.</li>
            </ul>
          </div>
        </section>

        {/* PRIVACY */}
        <section id="privacy" className="mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-3">
            Privacy Policy
          </h2>
          <div className="space-y-3 text-sm leading-6">
            <p>
              We respect your privacy and are committed to protecting your personal data. This policy describes
              what data we collect, why we collect it, and how we use it.
            </p>
            <ul className="list-disc ml-5">
              <li>Data we collect may include name, email, phone, address, and documents required for membership and tender participation.</li>
              <li>We use the data for verification, communication, payment processing, and statutory compliance.</li>
              <li>We do not sell your data. Limited sharing happens with secure service providers (e.g., payment gateways like Razorpay) strictly to provide services.</li>
              <li>Data security practices and access controls are applied. You can write to us for any data-related request.</li>
            </ul>
          </div>
        </section>

        {/* REFUNDS */}
        <section id="refunds" className="mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-3">
            Cancellation & Refunds
          </h2>
          <div className="space-y-3 text-sm leading-6">
            <p>
              Registration fees once paid are generally <b>non-refundable</b>. Any exceptional refund decisions will be taken
              only as per the applicable cooperative policies and statutory guidelines.
            </p>
            <ul className="list-disc ml-5">
              <li>Refunds (if any) are processed only to the original payment method, after due verification.</li>
              <li>Timelines for refund, if applicable, may vary based on banking/ gateway processes.</li>
              <li>Kindly review all details before making the payment to avoid disputes.</li>
            </ul>
          </div>
        </section>

        {/* SHIPPING */}
        <section id="shipping" className="mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-3">
            Shipping / Delivery Policy
          </h2>
          <div className="space-y-3 text-sm leading-6">
            <p>
              This is an online cooperative portal. We do not ship physical goods. All documents, receipts and
              communications are provided digitally via the portal and/or email.
            </p>
            <ul className="list-disc ml-5">
              <li>No physical shipping is applicable for membership/tender registration.</li>
              <li>Wherever physical dispatch is required (rare cases), the timelines and charges will be intimated separately.</li>
            </ul>
          </div>
        </section>

        {/* CONTACT */}
        <section id="contact" className="mb-4">
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-3">
            Contact Us
          </h2>
          <div className="space-y-3 text-sm leading-6">
            <p><b>Shine Agri Allied & Marketing Multistate Cooperative Society Ltd.</b></p>
            <p>
              Address: 48, 1st Amar Arcade, Nilpur, Taluka Dantiwada, Banaskantha, Gujarat – 385505<br/>
              Email: <a className="text-emerald-700 hover:underline" href="mailto:info@shineagri.org">info@shineagri.org</a> &nbsp;|&nbsp;
              Phone: <a className="text-emerald-700 hover:underline" href="tel:+918490884020">+91-8490884020</a>
            </p>
            <p className="text-xs text-gray-500">
              Last updated: {new Date().toLocaleDateString("en-IN")}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
